/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel } from '@/wpt-lib/pdf/useData';

const ServiceAndEngagement = ({
    keyPerformanceIndicatorsService,
    serviceOrEngagement,
    internalOrExternalGoalService,
    areasOfContributionService,
    initiativesService,
}: Partial<{
    keyPerformanceIndicatorsService: string;
    serviceOrEngagement: string;
    internalOrExternalGoalService: string;
    areasOfContributionService: string;
    initiativesService: string;
}>) => (
    <>
        {keyPerformanceIndicatorsService && (
            <Row>
                <ValueCell label="Key Performance Indicators (KPIs)" value={keyPerformanceIndicatorsService} />
            </Row>
        )}
        <Row>
            <ValueCell
                label="Service Or Engagement Goal"
                value={useLabel('serviceOrEngagement', serviceOrEngagement ?? 'n/a')}
            />
            <ValueCell
                label="Internal Or External Goal"
                value={useLabel('internalOrExternalGoalService', internalOrExternalGoalService ?? 'n/a')}
            />
        </Row>
        {areasOfContributionService && (
            <Row>
                <ValueCell label="Areas Of Contribution To The Faculty" value={areasOfContributionService} />
            </Row>
        )}
        {initiativesService && (
            <Row>
                <ValueCell label="Initiatives In Support Of Faculty" value={initiativesService} />
            </Row>
        )}
    </>
);

export default ServiceAndEngagement;
